export default __webpack_public_path__ + "static/top-50-plg-26ed851e04271ec62b3b5599d79a4a0e.png";